<template>
  <div class="loader d-flex justify-content-center align-items-center flex-column">
    <img src="../assets/loader.png" alt="Loading" />
    <p>
      Please
      <span>wait...</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Loader"
};
</script>

<style scoped lang="scss">
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00162c;
  z-index: 999;
  img {
    animation: rotating 2s linear infinite;
  }
  p {
    font-family: "Times New Roman", Times, serif;
    color: #fff;
    font-weight: bold;
    font-size: 2em;
    animation: jump 2s infinite;
    animation-timing-function: linear;
    span {
      color: rgb(197, 147, 8);
    }
  }
}

@keyframes jump {
  0% {
    opacity: 100%;
  }
  50% {
    opacity: 0%;
  }
  100% {
    opacity: 100%;
  }
}
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
